import { render, staticRenderFns } from "./Screens.vue?vue&type=template&id=2859443c&scoped=true"
import script from "./Screens.vue?vue&type=script&lang=js"
export * from "./Screens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2859443c",
  null
  
)

export default component.exports